"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Config", {
  enumerable: true,
  get: function get() {
    return _config.Config;
  }
});
Object.defineProperty(exports, "ConfigManager", {
  enumerable: true,
  get: function get() {
    return _manager.Manager;
  }
});

var _config = require("./config");

var _manager = require("./manager");


//////////////////
// WEBPACK FOOTER
// ./~/@weike/toolkit/lib/config/index.js
// module id = 582
// module chunks = 6